import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { I18nService } from "../../../core/i18n";
import { TicketStatus } from "../../models/ticket.model";


@Component({
    selector: 'charla-ticket-status',
    template: `
        <span class="status" [ngClass]="{ 
                                'open': status == TicketStatus.Open, 
                                'in-progress': status == TicketStatus.InProgress || status == TicketStatus.PendingCustomer, 
                                'closed': status == TicketStatus.Closed || status == TicketStatus.Resolved }">
            {{ lookup[status - 1] }} <span *ngIf="post">{{post}}</span>
        </span>
    `,
    styleUrls: ['status.component.scss'],
    imports: [CommonModule]
  })
  export class CharlaTicketStatusComponent {

    private i18n = inject(I18nService);
    @Input() status: number = 0;
    @Input() post: string = "";
    TicketStatus = TicketStatus;
    lookup: string[] = [this.i18n.t('inbox.components.ticket_status.status.open', 'Open'), this.i18n.t('inbox.components.ticket_status.status.in_progress', 'In Progress'), this.i18n.t('inbox.components.ticket_status.status.closed', 'Closed'), this.i18n.t('inbox.components.ticket_status.status.pending_customer', 'Pending Customer'), this.i18n.t('inbox.components.ticket_status.status.resolved', 'Resolved')]; 

    constructor(
    ){

    }


  }